import React, { useState, useEffect } from "react";

const SubjectMockTestLinkForm = ({ subject, mockTests, onSubmit, onClose }) => {
  const [linkedPackages, setLinkedPackages] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (subject && mockTests) {
      // Check reverse relationship: find mockTests whose subjects array includes this subject
      const currentlyLinked = mockTests
        .filter(mockTest => 
          (mockTest.subjects || []).some(subjId => 
            (subjId._id || subjId) === subject._id
          )
        )
        .map(pkg => ({
          mockTestId: pkg._id,
          mockTest: pkg,
          isLinked: true
        }));
      setLinkedPackages(currentlyLinked);
    }
  }, [subject, mockTests]);

  const filteredMockTests = mockTests.filter(m =>
    m.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
    m.description?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const toggleMockTestLink = (mockTest) => {
    setLinkedPackages(prev => {
      const existing = prev.find(p => p.mockTestId === mockTest._id);
      if (existing) {
        return prev.filter(p => p.mockTestId !== mockTest._id);
      }
      return [...prev, { mockTestId: mockTest._id, mockTest, isLinked: false }];
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      const result = await onSubmit(subject._id, linkedPackages);
      if (result?.success) onClose();
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content-form bg-white rounded-16 shadow-5" style={{ maxWidth: '900px', maxHeight: '90vh', overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
        <div className="modal-header">
          <div>
            <h4 className="modal-title">Link {subject?.title} to Mock Test Packages</h4>
            <p className="text-13 text-light-1 mt-5">
              Select mock test packages this subject belongs to. Pricing is set on each package.
            </p>
          </div>
          <button onClick={onClose} className="modal-close-btn">
            <i className="icon-close"></i>
          </button>
        </div>
        <div className="modal-body" style={{ overflow: 'auto', flex: 1 }}>
          <form onSubmit={handleSubmit} className="content-form">
            <div className="form-group mb-20">
              <input
                type="text"
                placeholder="Search mock test packages..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="form-input"
                style={{ padding: '10px 15px' }}
              />
            </div>
            <div className="subjects-link-list" style={{ maxHeight: '400px', overflow: 'auto' }}>
              {filteredMockTests.length === 0 ? (
                <div className="text-center py-30 text-13 text-light-2">
                  <i className="icon-search text-30 mb-10"></i>
                  <p>{searchTerm ? 'No packages found matching your search' : 'No mock test packages yet'}</p>
                </div>
              ) : (
                filteredMockTests.map((mockTest) => {
                  const linkedItem = linkedPackages.find(p => p.mockTestId === mockTest._id);
                  const isLinked = !!linkedItem;
                  return (
                    <div key={mockTest._id} className="subject-link-item bg-light-5 rounded-8 p-15 mb-15 border border-light-3">
                      <div className="d-flex items-center justify-between">
                        <label className="checkbox-label" style={{ margin: 0, cursor: 'pointer', flex: 1 }}>
                          <input type="checkbox" checked={isLinked} onChange={() => toggleMockTestLink(mockTest)} className="form-checkbox mr-10" />
                          <div className="d-flex items-center">
                            <div className="size-35 d-flex justify-center items-center rounded-6 mr-10" style={{ backgroundColor: (mockTest.color || '#dc2626') + '20', color: mockTest.color || '#dc2626' }}>
                              <i className="icon-clipboard-list text-14"></i>
                            </div>
                            <div>
                              <div className="text-14 fw-500">{mockTest.title}</div>
                              <div className="text-12 text-light-2">{mockTest.description || 'No description'}</div>
                              {mockTest.isFree && <span className="badge bg-green-1 text-green text-10 ml-5">Free</span>}
                              {!mockTest.isFree && mockTest.isPurchasable && (
                                <span className="text-11 text-light-1 ml-5">₹{mockTest.discountPrice || mockTest.price}</span>
                              )}
                            </div>
                          </div>
                        </label>
                      </div>
                    </div>
                  );
                })
              )}
            </div>
            <div className="modal-footer mt-20">
              <button type="button" onClick={onClose} className="btn-cancel">Cancel</button>
              <button type="submit" disabled={submitting} className="btn-primary bg-purple">
                {submitting ? 'Saving...' : 'Save Links'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default SubjectMockTestLinkForm;
